import React, { useState, useEffect } from 'react';
import { Grid, Typography, MenuItem, Box, CircularProgress, FormControl, InputLabel, Select } from '@mui/material';
import { useClientBuildings } from '../../../../reactQuery/building';

const BuildingSelector = ({ selectedClient, selectedBuilding, setSelectedBuilding, setSelectedBuildingData }) => {
  const [buildings, setBuildings] = useState([]);

  // Use React Query to fetch buildings when client is selected
  const {
    responseData: buildingsData,
    isLoading: isBuildingsLoading,
    error: buildingsError,
  } = useClientBuildings(
    { page: 1, pageSize: 100, pagination: false, clientId: selectedClient },
    selectedClient
  );

  // Reset building selection when client changes or is cleared
  useEffect(() => {
    if (!selectedClient) {
      setBuildings([]);
      setSelectedBuilding("");
      if (setSelectedBuildingData) {
        setSelectedBuildingData(null);
      }
    }
  }, [selectedClient, setSelectedBuilding, setSelectedBuildingData]);

  // Format buildings data for dropdown and store selected building data
  useEffect(() => {
    if (buildingsData && buildingsData.length > 0) {
      const formattedBuildings = buildingsData.map((building) => ({
        value: building.building_id,
        label: building.address || building.name,
        data: building,
      }));
      setBuildings(formattedBuildings);
    } else {
      setBuildings([]);
      if (selectedClient) {
        setSelectedBuilding("");
        if (setSelectedBuildingData) {
          setSelectedBuildingData(null);
        }
      }
    }
  }, [buildingsData, selectedClient, setSelectedBuilding, setSelectedBuildingData]);

  return (
    <Grid item xs={12}>
      <FormControl fullWidth variant="outlined">
        <InputLabel shrink htmlFor="building-select">
          Building
        </InputLabel>
        <Select
          id="building-select"
          value={selectedBuilding || ""}
          onChange={(e) => {
            setSelectedBuilding(e.target.value);
            if (setSelectedBuildingData) {
              const selectedBuildingObj = buildings.find(b => b.value === e.target.value);
              setSelectedBuildingData(selectedBuildingObj ? selectedBuildingObj.data : null);
            }
          }}
          disabled={!selectedClient || isBuildingsLoading}
          displayEmpty
          label="Building"
        >
        <MenuItem value="" disabled>
          <em>{isBuildingsLoading ? "Loading buildings..." : "Select building"}</em>
        </MenuItem>
        {isBuildingsLoading ? (
          <MenuItem disabled>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <CircularProgress size={20} sx={{ mr: 1 }} /> Loading...
            </Box>
          </MenuItem>
        ) : buildings.length > 0 ? (
          buildings.map((building) => (
            <MenuItem key={building.value} value={building.value}>
              {building.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No buildings found</MenuItem>
        )}
      </Select>
      </FormControl>
      {buildingsError && (
        <Typography color="error" variant="caption">
          Error loading buildings. Please try again.
        </Typography>
      )}
    </Grid>
  );
};

export default BuildingSelector;
